import StepIndicatorStep from './StepIndicatorStep';
import useStepIndicator from './useStepIndicator';

export type SingleStepIndicator = {
  name: string;
  url: string | string[];
};

export type MultiStepIndicator = {
  name: string;
  substeps: SingleStepIndicator[];
};

export type StepIndicator = SingleStepIndicator | MultiStepIndicator;

export interface StepIndicatorProps {
  steps: StepIndicator[];
  isLoading?: boolean;
}

const StepIndicator: React.FunctionComponent<StepIndicatorProps> = function ({
  steps,
  isLoading = false,
}) {
  const { formattedSteps } = useStepIndicator(steps);
  return (
    <div className="flex flex-col">
      {formattedSteps.map((step, index) => (
        <StepIndicatorStep
          key={step.number}
          step={step}
          first={index === 0}
          last={index === formattedSteps.length - 1}
          isLoading={isLoading}
        />
      ))}
    </div>
  );
};

export default StepIndicator;
